// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DSbxKy2nxQiOCgDffnWP {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  position: relative;
  color: white;
  font-size: 22px;
  font-weight: bold;
  font-family: Chakra Petch;
  text-transform: uppercase;
  max-width: 600px;
  width: fit-content;
  column-gap: 24px;
  margin: 0;
  padding: 8px 16px 8px 16px;
  cursor: pointer;
  background: rgba(70, 113, 113, 0.5);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
}
@media (max-width: 1000px) {
  .DSbxKy2nxQiOCgDffnWP {
    width: 100%;
  }
}
.DSbxKy2nxQiOCgDffnWP:hover {
  color: #48CAE4;
}

.sOkPeB3poH9MvxJzjKqJ {
  width: 100%;
  margin-bottom: 32px;
}

.GSrnRZi4wxRiM5kQNKdW {
  height: 60vh;
  overflow-y: scroll;
  padding: 16px;
  max-height: 60vh;
}

.mZ8KERBwkXHrmeqEP3mL {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding: 0 16px;
  max-height: 60vh;
  margin-bottom: 8px;
}

.qOMF97fCIYagbGdmEkll {
  color: white;
  font-size: 16px;
  font-weight: bold;
  font-family: Chakra Petch;
  text-transform: uppercase;
  padding: 8px 0;
}

.uTgUVbqjRy5QZDq_UfAB {
  color: white;
  font-size: 14px;
  font-weight: 500;
  font-family: Chakra Petch;
  text-transform: uppercase;
  padding: 8px 0;
}

.EcV1KsPUUwxVsbR5zFLT {
  height: 32px;
  margin-bottom: 4px;
  border-bottom: 1px solid #C4C4C4;
  padding: 0 8px 0 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.EcV1KsPUUwxVsbR5zFLT:hover {
  color: #48CAE4;
}

.iijDvrG0f5zLG2Iqcqy4 {
  height: 32px;
  margin-bottom: 4px;
  padding: 0 8px 0 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;
  border-bottom: 1px solid #48CAE4;
  color: #48CAE4;
}

.xT1j04Drrv857eQ4XOd6 {
  color: #7D8182;
}

.S9FExNhW_B93Ms2EE5S6 {
  width: 28px;
  height: 28px;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/Components/TokenModalSelect/TokenModalSelect.module.scss"],"names":[],"mappings":"AACA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,eAAA;EACA,mCAAA;EACA,2CAAA;EACA,mBAAA;AAAD;AACC;EArBD;IAsBE,WAAA;EAEA;AACF;AAAC;EACC,cAAA;AAEF;;AAEA;EACC,WAAA;EACA,mBAAA;AACD;;AAEA;EACC,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AACD;;AAEA;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACD;;AAEA;EACC,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;AACD;;AAEA;EACC,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;AACD;;AAEA;EACC,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AACD;AAAC;EACC,cAAA;AAEF;;AAEA;EACC,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,cAAA;AACD;;AAEA;EACC,cAAA;AACD;;AAEA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AACD","sourcesContent":["\r\n.modalButtonContainer {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\theight: 48px;\r\n\tposition: relative;\r\n\tcolor: white;\r\n\tfont-size: 22px;\r\n\tfont-weight: bold;\r\n\tfont-family: Chakra Petch;\r\n\ttext-transform: uppercase;\r\n\tmax-width: 600px;\r\n\twidth: fit-content;\r\n\tcolumn-gap: 24px;\r\n\tmargin: 0;\r\n\tpadding: 8px 16px 8px 16px;\r\n\tcursor: pointer;\r\n\tbackground: rgba(70, 113, 113, 0.5);\r\n\tbox-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\r\n\tborder-radius: 16px;\r\n\t@media (max-width:1000px) {\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t&:hover {\r\n\t\tcolor: #48CAE4;\r\n\t}\r\n}\r\n\r\n.searchContainer {\r\n\twidth: 100%;\r\n\tmargin-bottom: 32px;\r\n}\r\n\r\n.tokenList {\r\n\theight: 60vh;\r\n\toverflow-y: scroll;\r\n\tpadding: 16px;\r\n\tmax-height: 60vh;\r\n}\r\n\r\n.inWalletTokenList {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\toverflow-y: scroll;\r\n\tpadding: 0 16px;\r\n\tmax-height: 60vh;\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n.tokenInWalletText {\r\n\tcolor: white;\r\n\tfont-size: 16px;\r\n\tfont-weight: bold;\r\n\tfont-family: Chakra Petch;\r\n\ttext-transform: uppercase;\r\n\tpadding: 8px 0;\r\n}\r\n\r\n.tokenSearchMessage {\r\n\tcolor: white;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tfont-family: Chakra Petch;\r\n\ttext-transform: uppercase;\r\n\tpadding: 8px 0;\r\n}\r\n\r\n.tokenOption {\r\n\theight: 32px;\r\n\tmargin-bottom: 4px;\r\n\tborder-bottom: 1px solid  #C4C4C4;\r\n\tpadding: 0 8px 0 8px;\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: flex-start;\r\n\talign-items: center;\r\n\tcolumn-gap: 16px;\r\n\tcursor: pointer;\r\n\toverflow: hidden;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\t&:hover {\r\n\t\tcolor: #48CAE4;\r\n\t}\r\n}\r\n\r\n.tokenOptionActive {\r\n\theight: 32px;\r\n\tmargin-bottom: 4px;\r\n\tpadding: 0 8px 0 8px;\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: flex-start;\r\n\talign-items: center;\r\n\tcolumn-gap: 16px;\r\n\tborder-bottom: 1px solid  #48CAE4;\r\n\tcolor: #48CAE4;\r\n}\r\n\r\n.tokenOptionBalance {\r\n\tcolor:  #7D8182;\r\n}\r\n\r\n.tokenIcon {\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tborder-radius: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalButtonContainer": `DSbxKy2nxQiOCgDffnWP`,
	"searchContainer": `sOkPeB3poH9MvxJzjKqJ`,
	"tokenList": `GSrnRZi4wxRiM5kQNKdW`,
	"inWalletTokenList": `mZ8KERBwkXHrmeqEP3mL`,
	"tokenInWalletText": `qOMF97fCIYagbGdmEkll`,
	"tokenSearchMessage": `uTgUVbqjRy5QZDq_UfAB`,
	"tokenOption": `EcV1KsPUUwxVsbR5zFLT`,
	"tokenOptionActive": `iijDvrG0f5zLG2Iqcqy4`,
	"tokenOptionBalance": `xT1j04Drrv857eQ4XOd6`,
	"tokenIcon": `S9FExNhW_B93Ms2EE5S6`
};
export default ___CSS_LOADER_EXPORT___;
